import { render, staticRenderFns } from "./bimTextHint.vue?vue&type=template&id=46b016bf&scoped=true&lang=html&"
import script from "./bimTextHint.vue?vue&type=script&lang=js&"
export * from "./bimTextHint.vue?vue&type=script&lang=js&"
import style0 from "./bimTextHint.vue?vue&type=style&index=0&id=46b016bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b016bf",
  null
  
)

export default component.exports